import { callPexels, PexelsImage, PexelsRequest } from "./pexels";
import { callUnsplash, UnsplashImage, UnsplashRequest } from "./unsplash";
import { callPixabay, PixabayImage, PixabayRequest } from "./pixabay";

export function pexelsImageToUnsplashImageFormat(
  image: PexelsImage
): UnsplashImage {
  return {
    id: image.id.toString(),
    description: null,
    alt_description: image.alt || null,
    urls: {
      raw: image.src.original,
      full: image.src.large2x,
      regular: image.src.large,
      small: image.src.medium,
      thumb: image.src.small
    },
    user: {
      name: image.photographer,
      username: image.photographer_url
    },
    width: image.width,
    height: image.height
  };
}

export function pixabayImageToUnsplashImageFormat(
  image: PixabayImage
): UnsplashImage {
  return {
    id: image.id.toString(),
    description: image.tags,
    alt_description: image.tags || null,
    urls: {
      raw: image.largeImageURL,
      full: image.fullHDURL || image.largeImageURL,
      regular: image.webformatURL,
      small: image.webformatURL,
      thumb: image.previewURL
    },
    user: {
      name: image.user,
      username: image.user
    },
    width: image.imageWidth,
    height: image.imageHeight
  };
}

const provider: "pexels" | "unsplash" | "pixabay" = "pixabay";

export function callImageService(request: PexelsRequest | UnsplashRequest | PixabayRequest, abortController: AbortController) {
  if (provider === "pexels") {
    return callPexels(request, abortController);
  } else if (provider === "pixabay") {
    return callPixabay(request, abortController);
  } else {
    return callUnsplash(request, abortController);
  }
}
